<app-accomodation-view
  [offer]="offer()"
  (backToMainPage)="backToMainPage()"
  (goToSubmitPage)="goToSubmitPage()"
  (reserve)="openDialog()"
  [isErrorRequest]="isErrorRequest()"
  [errorMessage]="errorMessage()" />
